/* tslint:disable */
/* eslint-disable */
/**
 * Wire API (development)
 * The API for the Clientwire messaging service.
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@clientwire.net
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Participant } from './participant';
import {
    ParticipantFromJSON,
    ParticipantFromJSONTyped,
    ParticipantToJSON,
    ParticipantToJSONTyped,
} from './participant';

/**
 * 
 * @export
 * @interface ParticipantListResponse
 */
export interface ParticipantListResponse {
    /**
     * A list of conversation participants.
     * @type {Array<Participant>}
     * @memberof ParticipantListResponse
     */
    participants: Array<Participant>;
}

/**
 * Check if a given object implements the ParticipantListResponse interface.
 */
export function instanceOfParticipantListResponse(value: object): value is ParticipantListResponse {
    if (!('participants' in value) || value['participants'] === undefined) return false;
    return true;
}

export function ParticipantListResponseFromJSON(json: any): ParticipantListResponse {
    return ParticipantListResponseFromJSONTyped(json, false);
}

export function ParticipantListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ParticipantListResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'participants': ((json['participants'] as Array<any>).map(ParticipantFromJSON)),
    };
}

export function ParticipantListResponseToJSON(json: any): ParticipantListResponse {
    return ParticipantListResponseToJSONTyped(json, false);
}

export function ParticipantListResponseToJSONTyped(value?: ParticipantListResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'participants': ((value['participants'] as Array<any>).map(ParticipantToJSON)),
    };
}

